import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
	downloadIcon: {
		height: 16,
		width: 16,
		fill: theme.palette.primary.main,
		marginRight: 8,
	},
	disabled: {
		background: '#ccc',
	},
	card: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 6,
		padding: theme.spacing(1, 2),
		border: '1px solid ' + theme.palette.primary.light,
		'& > p': {
			fontSize: 16,
			fontWeight: 500,
		},
	},
	button: {
		cursor: 'pointer',
		'&:hover': {
			background: '#e6e6e6',
		},
	},
	certificateButton: {
		[theme.breakpoints.down('xs')]: {
			marginBottom: 16,
		},
	},
	downloadButtonContainer: {
		display: 'flex',
		alignItems: 'flex-end',
		justifyContent: 'flex-end',
	},
}));
